// React Component: MessageNotification.js
import React from 'react';
import { GiNinjaHead } from "react-icons/gi";
import './MessageNotification.scss';
import ProgressSteps from './ProgressSteps';

const MessageNotification = ({ message, time }) => {
  return (
    <>
    <ProgressSteps completed={1} />
    <div className='v'>
    <><div className="message-notification">
          <div className="message-bubble">
              <span className="message-text">new news</span>
              <span className="message-time">17:09</span>
          </div>
          
      </div><div className="message-avatar">
              <GiNinjaHead size="2em" />
          </div></>
          </div>
          <div className='v'>
    <><div className="message-notificationa">
          <div className="message-bubble">
              <span className="message-text">new news</span>
              <span className="message-time">17:09</span>
          </div>
          
      </div><div className="message-avatar">
              <GiNinjaHead size="2em" />
          </div></>
          </div>
          </>
  );
};

export default MessageNotification;
